<script lang="ts">
	import DayPicker from 'src/components/TimePicker/DayPicker.svelte';

	export let editableObject;

	const days = editableObject.schedule.days.map((i: number) => (i = i == 0 ? 6 : i - 1)),
		onChangeDays = (e: CustomEvent) => {
			editableObject.schedule.days = e.detail.map((i: number) => (i = i == 6 ? 0 : i + 1));
		};
</script>

<DayPicker {days} on:change={onChangeDays} />
